 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		24: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		24: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors/pages/Blog/_slug/pages/Blog/index/pages/Projects/_slug/pages/Projects/ar/index/pages/Project/96db281f","1":"pages/Projects/ar/index/pages/Projects/index/pages/Projects/lab/index/pages/Projects/mediaSpace/inde/f727983f","2":"vendors/pages/Blog/_slug/pages/Kontakt/index/pages/Projects/_slug/pages/Workshop/_slug/pages/Worksho/a903a7bc","3":"pages/Blog/_slug/pages/Projects/_slug","4":"pages/Kontakt/index/pages/index","7":"layouts/default","8":"pages/About/index","9":"pages/Blog/_slug","10":"pages/Blog/index","11":"pages/Datenschutz/index","12":"pages/Impressum/index","13":"pages/Kontakt/index","14":"pages/Projects/_slug","15":"pages/Projects/ar/index","16":"pages/Projects/index","17":"pages/Projects/lab/index","18":"pages/Projects/mediaSpace/index","19":"pages/Projects/vr/index","20":"pages/Projects/webXR/index","21":"pages/Workshop/_slug","22":"pages/Workshop/index","23":"pages/index","26":"vendors/pages/index"}[chunkId]||chunkId) + ".chunk.js?v=2.3"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		601: function() {
 			return {
 				"./rapier_wasm3d_bg.js": {
 					"__wbindgen_number_new": function(p0f64) {
 						return installedModules[486].exports["S"](p0f64);
 					},
 					"__wbindgen_boolean_get": function(p0i32) {
 						return installedModules[486].exports["O"](p0i32);
 					},
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules[486].exports["T"](p0i32);
 					},
 					"__wbindgen_number_get": function(p0i32,p1i32) {
 						return installedModules[486].exports["R"](p0i32,p1i32);
 					},
 					"__wbindgen_is_function": function(p0i32) {
 						return installedModules[486].exports["P"](p0i32);
 					},
 					"__wbg_rawraycolliderintersection_new": function(p0i32) {
 						return installedModules[486].exports["K"](p0i32);
 					},
 					"__wbg_rawcontactforceevent_new": function(p0i32) {
 						return installedModules[486].exports["J"](p0i32);
 					},
 					"__wbg_call_01734de55d61e11d": function(p0i32,p1i32,p2i32) {
 						return installedModules[486].exports["A"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_call_4c92f6aec1e1d6e6": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules[486].exports["B"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_call_776890ca77946e2f": function(p0i32,p1i32,p2i32,p3i32,p4i32) {
 						return installedModules[486].exports["C"](p0i32,p1i32,p2i32,p3i32,p4i32);
 					},
 					"__wbg_bind_60a9a80cada2f33c": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules[486].exports["y"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_buffer_085ec1f694018c4f": function(p0i32) {
 						return installedModules[486].exports["z"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_6da8e527659b86aa": function(p0i32,p1i32,p2i32) {
 						return installedModules[486].exports["H"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_new_8125e318e6245eed": function(p0i32) {
 						return installedModules[486].exports["F"](p0i32);
 					},
 					"__wbg_set_5cf90238115182c3": function(p0i32,p1i32,p2i32) {
 						return installedModules[486].exports["L"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_length_72e2208bbc0efc61": function(p0i32) {
 						return installedModules[486].exports["D"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_69193e31c844b792": function(p0i32,p1i32,p2i32) {
 						return installedModules[486].exports["G"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_set_6146c51d49a2c0df": function(p0i32,p1i32,p2i32) {
 						return installedModules[486].exports["M"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_length_d7327c75a759af37": function(p0i32) {
 						return installedModules[486].exports["E"](p0i32);
 					},
 					"__wbg_newwithlength_68d29ab115d0099c": function(p0i32) {
 						return installedModules[486].exports["I"](p0i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules[486].exports["U"](p0i32,p1i32);
 					},
 					"__wbindgen_memory": function() {
 						return installedModules[486].exports["Q"]();
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"1":1,"2":1,"3":1,"4":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors/pages/Blog/_slug/pages/Blog/index/pages/Projects/_slug/pages/Projects/ar/index/pages/Project/96db281f","1":"pages/Projects/ar/index/pages/Projects/index/pages/Projects/lab/index/pages/Projects/mediaSpace/inde/f727983f","2":"vendors/pages/Blog/_slug/pages/Kontakt/index/pages/Projects/_slug/pages/Workshop/_slug/pages/Worksho/a903a7bc","3":"pages/Blog/_slug/pages/Projects/_slug","4":"pages/Kontakt/index/pages/index","7":"layouts/default","8":"pages/About/index","9":"pages/Blog/_slug","10":"pages/Blog/index","11":"pages/Datenschutz/index","12":"pages/Impressum/index","13":"pages/Kontakt/index","14":"pages/Projects/_slug","15":"pages/Projects/ar/index","16":"pages/Projects/index","17":"pages/Projects/lab/index","18":"pages/Projects/mediaSpace/index","19":"pages/Projects/vr/index","20":"pages/Projects/webXR/index","21":"pages/Workshop/_slug","22":"pages/Workshop/index","23":"pages/index","26":"vendors/pages/index"}[chunkId]||chunkId) + ".css?v=2.3";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "" + ({"0":"vendors/pages/Blog/_slug/pages/Blog/index/pages/Projects/_slug/pages/Projects/ar/index/pages/Project/96db281f","1":"pages/Projects/ar/index/pages/Projects/index/pages/Projects/lab/index/pages/Projects/mediaSpace/inde/f727983f","2":"vendors/pages/Blog/_slug/pages/Kontakt/index/pages/Projects/_slug/pages/Workshop/_slug/pages/Worksho/a903a7bc","3":"pages/Blog/_slug/pages/Projects/_slug","4":"pages/Kontakt/index/pages/index","7":"layouts/default","8":"pages/About/index","9":"pages/Blog/_slug","10":"pages/Blog/index","11":"pages/Datenschutz/index","12":"pages/Impressum/index","13":"pages/Kontakt/index","14":"pages/Projects/_slug","15":"pages/Projects/ar/index","16":"pages/Projects/index","17":"pages/Projects/lab/index","18":"pages/Projects/mediaSpace/index","19":"pages/Projects/vr/index","20":"pages/Projects/webXR/index","21":"pages/Workshop/_slug","22":"pages/Workshop/index","23":"pages/index","26":"vendors/pages/index"}[chunkId]||chunkId) + ".css?v=2.3";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"26":[601]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"601":"5edea88dc7500e212e0b"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
